import { getFontSize } from '../../constants/fontSizes';

export const iconInfoSectionStyles = () => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '20px',
    },
    iconContainer: {
      width: {xs: '40px', lg: '80px'},
      height: {xs: '40px', lg: '80px'},
      borderRadius: '50%',
      backgroundColor: '#3a3b3e',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    icon: {
      width: {xs: '20px', lg: '42px'},
      height: {xs: '20px', lg: '42px'},
      color: 'secondary.main',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& svg': {
        width: '42px',
        height: '42px',
        color: 'secondary.main',
        fill: 'currentColor',
      },
      '& img': {
        width: '42px',
        height: '42px',
        objectFit: 'contain',
      },
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: {xs: '2px', lg: '8px'},
      flex: 1,
    },
    title: {
      color: 'secondary.main',
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: getFontSize(32),
      lineHeight: {xs: '20px', md: '28px', lg: '39px', xl: '42px'},
      letterSpacing: '-1%',
    },
    subtitle: {
      color: '#FFFFFFCC',
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: getFontSize(20),
      lineHeight: {xs: '15px', md: '22px', lg: '28px', xl: '30px'},
      letterSpacing: '-1%',
    },
  };
};

